import png from './images/dragons.png'

export const colors = {
  dominant: '#EF3829',
  highlight: '#fcb53e',
}
export const fullname = 'Dragons'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/dragons.js